import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Pacman = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M13 12C11.346 12 10 10.654 10 9C10 8.448 10.448 8 11 8C11.552 8 12 8.448 12 9C12 9.551 12.449 10 13 10C13.551 10 14 9.551 14 9C14 8.448 14.448 8 15 8C15.552 8 16 8.448 16 9C16 10.654 14.654 12 13 12Z" />
		<path d="M27.574 22.182L18.744 16L27.574 9.81802C27.832 9.63702 28 9.33802 28 9.00002C28 8.80602 27.944 8.62502 27.848 8.47102C27.848 8.47102 27.83 8.44102 27.829 8.43902C25.294 4.40602 20.876 1.99902 16.001 1.99902C12.285 1.99902 8.775 3.46202 6.119 6.11802C3.463 8.77402 2 12.283 2 15.999C2 19.715 3.463 23.225 6.119 25.881C8.775 28.537 12.284 30 16.001 30C20.876 30 25.295 27.593 27.829 23.56C27.83 23.559 27.848 23.528 27.848 23.528C27.944 23.374 28 23.194 28 22.999C28 22.661 27.831 22.362 27.574 22.181V22.182ZM16 28C12.818 28 9.811 26.745 7.533 24.467C5.255 22.189 4 19.182 4 16C4 12.818 5.255 9.81102 7.533 7.53302C9.811 5.25502 12.818 4.00002 16 4.00002C19.867 4.00002 23.395 5.75802 25.618 8.74702L16.427 15.181C16.169 15.362 16 15.661 16 15.999C16 16.337 16.169 16.637 16.427 16.818V16.819L25.618 23.253C23.395 26.242 19.867 28 16 28Z" />
	</svg>
);

export default Pacman;
